(function () {
    'use strict';

    angular
        .module('app')
        .directive('pagination', pagination);

    function pagination() {
        var directive = {
            controller: ['$scope', controller],
            controllerAs: '$pagination',
            restrict: 'EA',
            transclude: false,
            template: '<div class="results-nav-container">' +
                      '<ul ng-show="pages.length > 1" class="pagination pagination-sm">' +
                      '<li class="pagination-first" ng-click="changePage(pages[0], true)"><a>First</a></li>' +
                      '<li class="pagination-prev" ng-click="!(page <= pages[0]) && changePage((page - 1), false)"><a>Previous</a></li>' +
                      '<li class="pagination-page" ng-if="startPage > 1" ng-click="rotatePagesBackward(false)"><a>...</a></li>' +
                      '<li class="pagination-page" ng-repeat="p in visiblePages" ng-class="{ active: page == p }" ng-click="page != p && changePage(p, false)"><a>{{ p }}</a></li>' +
                      '<li class="pagination-page" ng-if="pages.length > maxPages && endPage < pages.length" ng-click="rotatePagesForward(false)"><a>...</a></li>' +
                      '<li class="pagination-next" ng-click="!(page >= pages.length) && changePage((page + 1), false)"><a>Next</a></li>' +
                      '<li class="pagination-last" ng-click="changePage(pages[pages.length - 1], true)"><a>Last</a></li>' +
                      '</ul>' +
                      '</div>',
            scope: {
                results: "=",
                secondaryResults: "=",
                shownResults: "=",
                secondaryShownResults: "=",
                page: "=",
                pageSize: "=",
                secondaryPageSize: "=",
                pages: "=",
                maxPages: "="
            },
            link: link
        };

        return directive;

        function link($scope) {
            $scope.visiblePages = [];
            $scope.startPage = 1;
            $scope.endPage = $scope.startPage + $scope.maxPages - 1;

            $scope.$watch('pages', function () {
                $scope.endPage = $scope.startPage + ($scope.maxPages - 1);
                $scope.changePage($scope.page);
                $scope.visiblePages = $scope.pages.slice($scope.page - 1, $scope.page + $scope.maxPages - 1);
            });

            $scope.changePage = function (page, endJump) {
                $scope.page = page;

                var skip = (page - 1) * $scope.pageSize;

                $scope.shownResults = $scope.results.slice(skip, skip + $scope.pageSize);

                if ($scope.secondaryResults && $scope.secondaryShownResults && $scope.secondaryPageSize) {
                    var secondarySkip = (page - 1) * $scope.secondaryPageSize;
                    $scope.secondaryShownResults = $scope.secondaryResults.slice(secondarySkip, secondarySkip + $scope.secondaryPageSize);
                }

                if ($scope.page > $scope.endPage) {
                    $scope.rotatePagesForward(endJump);
                }

                if ($scope.page < $scope.startPage) {
                    $scope.rotatePagesBackward(endJump);
                }
            }

            $scope.rotatePagesForward = function (endJump) {
                if (endJump) {
                    $scope.endPage = $scope.page;

                    if (($scope.endPage % $scope.maxPages) === 0) {
                        $scope.startPage = $scope.endPage - $scope.maxPages + 1;
                    } else {
                        $scope.startPage = $scope.endPage - ($scope.endPage % $scope.maxPages) + 1;
                    }
                } else {
                    $scope.startPage = $scope.endPage + 1;
                    $scope.endPage = $scope.startPage + $scope.maxPages - 1;

                    if ($scope.endPage > $scope.pages.length) {
                        $scope.endPage = $scope.pages.length;
                    }

                    $scope.changePage($scope.startPage, false);
                }

                $scope.visiblePages = $scope.pages.slice($scope.startPage - 1, $scope.endPage);
            }

            $scope.rotatePagesBackward = function (endJump) {
                if (endJump) {
                    $scope.startPage = 1;
                    $scope.endPage = $scope.startPage + $scope.maxPages - 1;
                } else {
                    $scope.startPage = $scope.startPage - $scope.maxPages;

                    if ($scope.startPage < 1) {
                        $scope.startPage = 1;
                    }

                    $scope.endPage = $scope.startPage + $scope.maxPages - 1;

                    $scope.changePage($scope.startPage, false);
                }

                $scope.visiblePages = $scope.pages.slice($scope.startPage - 1, $scope.endPage);
            }
        }

        function controller($scope) {
            var $ctrl = this;

            
        }
    }
})();


//////////////////
// WEBPACK FOOTER
// ./static/common/js/directives/_searchPagination.js
// module id = 15
// module chunks = 0